// extracted by mini-css-extract-plugin
module.exports = {"fourthFold":"fourthFold_fourthFold__yuTxj","heading":"fourthFold_heading__Q52TK","subParagraph":"fourthFold_subParagraph__gbjOV"};